import { defineComponent, ref } from 'vue';
import SupportTableComponent from '@/components/otherPage/support/SupportTable.vue';
import SupportFormComponent from '@/components/otherPage/support/supportForm/SupportForm.vue';
import LawTableComponent from '@/components/otherPage/law/LawTable.vue';
import LawFormComponent from '@/components/otherPage/law/lawForm/LawForm.vue';
import DownloadTableComponent from '@/components/otherPage/download/DownloadTable.vue';
import DownloadFormComponent from '@/components/otherPage/download/downloadForm/DownloadForm.vue';

export default defineComponent({
  name: 'OtherPage',
  components: {
    SupportTableComponent,
    SupportFormComponent,
    LawTableComponent,
    LawFormComponent,
    DownloadTableComponent,
    DownloadFormComponent,
  },
  setup: () => {
    const selectedSupportId = ref<number | null>();
    const supportForm = ref<InstanceType<typeof SupportFormComponent>>();
    const selectedLawId = ref<number | null>();
    const lawForm = ref<InstanceType<typeof LawFormComponent>>();
    const selectedDownloadId = ref<number | null>();
    const downloadForm = ref<InstanceType<typeof DownloadFormComponent>>();

    const createSupportClick = () => {
      Promise.resolve(selectedSupportId.value = null)
        .then(() => supportForm.value?.show());
    };

    const editSupportClick = (supportId: number) => {
      Promise.resolve(selectedSupportId.value = supportId)
        .then(() => supportForm.value?.show());
    };

    const createLawClick = () => {
      Promise.resolve(selectedLawId.value = null)
        .then(() => lawForm.value?.show());
    };

    const editLawClick = (lawId: number) => {
      Promise.resolve(selectedLawId.value = lawId)
        .then(() => lawForm.value?.show());
    };

    const createDownloadClick = () => {
      Promise.resolve(selectedDownloadId.value = null)
        .then(() => downloadForm.value?.show());
    };

    const editDownloadClick = (downloadId: number) => {
      Promise.resolve(selectedDownloadId.value = downloadId)
        .then(() => downloadForm.value?.show());
    };

    return {
      selectedSupportId,
      supportForm,
      selectedLawId,
      lawForm,
      selectedDownloadId,
      downloadForm,
      createSupportClick,
      editSupportClick,
      createLawClick,
      editLawClick,
      createDownloadClick,
      editDownloadClick,
    };
  }
});
